
import { Button, CircularProgress } from '@material-ui/core'
import { green } from '@material-ui/core/colors'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles(theme => ({
  circularProgress: {
    marginRight: theme.spacing(1),
    position: 'absolute',
    zIndex: 1,
  },
  root: {
    '&:hover': {
      backgroundColor: props => props.success && green[700],
    },
    backgroundColor: props => props.success && green[500],
    position: 'relative',
    width: props => props.width && props.width,
  },
}))

/*
    This component extends the Material Button component
    Two properties added:
        - Sets the type of the button to submit type
        - submitting prop toggles the loading state of the button
*/
const SubmitButton = ({ children, submitting, success, variant, width, ...others }) => {
  const classes = useStyles({ success, width })
  return (
    <Button
      {...others}
      className={classes.root}
      disabled={submitting}
      type="submit"
      variant={success ? 'contained' : variant}
    >
      {submitting && (
        <CircularProgress
          className={classes.circularProgress}
          size={others.size === 'large' ? 24 : 16}
        />
      )}
      {children}
    </Button>
  )
}

export default SubmitButton
